import type { Release } from '../releases';

export default {
  id: '2026-11-03-estimate-takeoffs',
  at: '2026-11-04T09:48:00Z',
  title: 'Сметы: ведомость объёмов проекта',
  modules: ['estimates'],
  items: [
    'На вкладке «Сметы» проекта — ведомость объёмов: загрузка из Excel с привязкой к комплекту и листам ПСД.',
    'Позиция сметы связывается со строкой ведомости и берёт из неё объём; позиция пересчитывается сама.',
    'Проверка сметы показывает работы без строки ведомости и позиции, где объём не равен ведомости.',
  ],
  why: 'Объём в смете должен опираться на чертежи: теперь видно, откуда взят объём и где он расходится с ведомостью.',
  link: '/projects',
} satisfies Release;
